/**
 * CLE-2811 — styles shared by the generation-progress panel's parts. Colours are the theme's: purple
 * (`--primary-color`) for what is happening now, green for what is done, the secondary text colour for
 * what is still to come.
 */

import styled, { keyframes } from "styled-components";

/** The active phase's ring: a soft breath, not a flash. */
export const pulse = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(91, 77, 253, 0.35); }
  70% { box-shadow: 0 0 0 0.45rem rgba(91, 77, 253, 0); }
  100% { box-shadow: 0 0 0 0 rgba(91, 77, 253, 0); }
`;

/** The typing cursor at the end of the AI's narration. */
export const blink = keyframes`
  0%, 49% { opacity: 1; }
  50%, 100% { opacity: 0; }
`;

export const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(2px); }
  to { opacity: 1; transform: none; }
`;

/** A section's small heading: "Documents", "What it is looking for", "Actions". */
export const SectionTitle = styled.h4`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin: 0 0 0.6rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-color);
`;

/** A thin PrimeReact ProgressBar: the theme's default is 1.5rem tall, too heavy for a row. */
export const thinBar = (heightRem: number) => ({
  height: `${heightRem}rem`,
  borderRadius: "999px",
});

export const GREEN = "var(--green-600, #1da750)";
